import React from 'react';
import { ChevronLeft } from 'lucide-react';

/* Unified bordered back button used as every tile's main exit. Accent must be a 6-digit hex. */
export const BackPill = ({ onClick, accent = '#D4AF37', label = 'Back', testId, ariaLabel }) => (
  <button type="button" onClick={onClick} data-testid={testId} aria-label={ariaLabel || label}
    className="relative z-10 flex-shrink-0 h-8 px-3 rounded-full flex items-center gap-1 whitespace-nowrap active:scale-95 transition-transform"
    style={{ border: `1px solid ${accent}8C`, background: `${accent}14`, boxShadow: `0 0 10px ${accent}40`, color: accent }}>
    <ChevronLeft size={16} />
    <span className="font-['Outfit'] uppercase" style={{ fontSize: 11, letterSpacing: '0.18em' }}>{label}</span>
  </button>
);

export default BackPill;
